<template>
  <li v-if="requestData.length" class="c-company-card__line">
    <h3 class="c-company-card__subtitle">Договор:</h3>
    <div class="c-company-card__info">
      <ul class="c-company-card__list">
        <li
          v-for="request in requestData"
          :key="request.id"
          class="c-company-card__item"
        >
          <div v-if="request.document.number" class="c-text">
            <span>{{ request.exporter_org.short_name }}</span> /
            {{ contracNumber(request.document) }}<br />
          </div>
        </li>
      </ul>
    </div>
  </li>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
const Contracts = RepositoryFactory.get('contractsRepository')

import { loadError } from '@/datas/Messages'
const EXPAND = '&expand=document,exporter_org,carrier_org'

export default {
  name: 'ContractsList',
  props: {
    contract: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      requestData: {},
    }
  },
  computed: {
    contracNumber() {
      return document =>
        Object.prototype.toString.call(document.number) === '[object String]'
          ? `№ ${document.number}`
          : `Нет данных`
    },
  },
  watch: {
    contract: {
      immediate: true,
      handler() {
        this.requestData = {}
        this.init()
      },
    },
  },
  beforeDestroy() {
    this.closeNotify()
    this.requestData = Object.create(null)
  },
  methods: {
    closeNotify() {
      this.$notify.closeAll()
    },
    checkDocumentHandler(item) {
      return (
        Object.prototype.hasOwnProperty.call(item, 'document') &&
        Boolean(item.document.number)
      )
    },
    async init() {
      let { carrier_org_inn: cOrgInn, exporter_org_inn: eOrgInn } =
        this.contract

      try {
        if (!cOrgInn || !eOrgInn) {
          return
        }
        let result = await Contracts.findContractsByInn(
          cOrgInn,
          eOrgInn,
          EXPAND,
        )

        if (Object.prototype.hasOwnProperty.call(result, 'data')) {
          let { items } = result.data

          if (items.some(this.checkDocumentHandler)) {
            this.requestData = items
          }
        }
      } catch (e) {
        this.closeNotify()
        this.$notify({
          message: loadError,
          duration: 0,
        })
      }
    },
  },
}
</script>

<style></style>
